<template>
    <div class="bg-white p-md-5 p-2 pb-1 mb-3 rounded">
        <div class="container-fluid">
            <h2 class="ranking-title mb-3">Bootcamps</h2>
            <span>Conoce las opciones de bootcamps para complementar la educación de tus colaboradores</span>

            <div class="d-sm-flex align-items-center justify-content-between my-4 gap-2">
                <div class="justify-content-star d-flex">
                    <span>{{ paginationInfo }}</span>
                </div>
                <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                    <search-input-component :search="search" @onSearch="onFilterSearch($event)"></search-input-component>
                    <a href="#newbootcamp" class="btn bg-utel text-white rounded-8 mx-1 my-2 pt-2" v-if="is_super_admin">Agregar Bootcamp</a>
                </div>
            </div>
            <div class="row mt-4" v-if="paginatedItems.length > 0" ref="paginationContainer">
                <div class="col-md-4" v-for="(item) in paginatedItems" :key="item.id">
                    <div class="card p-0 rounded-8 h-100 ">
                        <button class="btn btn-primary updatebootcampbutton px-2" @click="openEditModal(item)" v-if="is_super_admin">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <div class="card-body p-0">
                            <img src="/images/preview_bootcamps.jpg" alt="" class="card-img-top">
                            <div class="d-flex px-3 mt-3">
                                <span class="badge p-2 mx-3 badge-bootcamp rounded-3">Bootcamp</span>
                                <span class="badge p-2 mx-3 badge-duration rounded-3">
                                    <i class="duration-icon fa fa-calendar-days"></i>
                                    {{ getFormattedTime(item.program_time) }}
                                </span>
                            </div>
                            <div class="row mt-3 px-3">
                                <div class="col-md-12">
                                    <h4>{{ item.title }}</h4>
                                    <p>{{ item.description}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer py-3 custom-card-footer">
                            <a :href="item.cta" target="_blank" class="btn d-block mx-auto bootcamp-link btn-outline-primary bg-utel-v2-secondary rounded-8 text-center mx-auto py-2 px-5">
                                Ver más
                                <i class="fa-brands fa-whatsapp ml-2"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" v-if="paginatedItems.length === 0 && !loading">
                <div class="col-md-12 text-center">
                    <span>No hay bootcamps para mostrar</span>
                </div>
            </div>
            <div class="row mt-4" v-if="loading">
                <div class="col-md-12 text-center">
                    <span>Cargando...</span>
                </div>
            </div>
            <div class="my-4">
                <v-pagination v-model="page" :length="totalPages" @input="updatePage" next-icon='fas fa-angle-right' prev-icon='fas fa-angle-left'></v-pagination>
            </div>
        </div>
        <modaleditbootcamp
            :bootcamp="activeBootcamp"
            :is_super_admin="is_super_admin"
            :url_get="url"
            @onCancel="closeEditModal"
            @onRefresh="refreshBootcamps"
            v-if="isEditModalVisible"
        ></modaleditbootcamp>
    </div>
</template>
<script>
    import modaleditbootcamp from './ModalEditBootcamp.vue';
    export default {
        props: ['url', 'is_super_admin'],
        components: {
            modaleditbootcamp
        },
        data(){
            return {
                bootcamps: [],
                search: '',
                page: 1,
                loading: false,
                itemsPerPage: 9,
                activeBootcamp: null,
                isEditModalVisible: false
            }
        },
        created(){
            this.$parent.$on('refreshbootcamps', this.onNewBootcamp);
        },
        computed: {
            totalPages() {
                return Math.ceil(this.bootcamps.length / this.itemsPerPage);
            },
            paginatedItems() {
                const startIndex = (this.page - 1) * this.itemsPerPage;
                const endIndex = startIndex + this.itemsPerPage;
                return this.filteredItems.slice(startIndex, endIndex);
            },
            filteredItems() {
                const query = this.search.toLowerCase();
                return this.bootcamps.filter(bootcamp => {
                    const nameMatch = bootcamp.title.toLowerCase().includes(query);
                    const descriptionMatch = bootcamp.description.toLowerCase().includes(query);
                    return nameMatch || descriptionMatch;
                });
            },
            paginationInfo() {
                const startIndex = (this.page - 1) * this.itemsPerPage + 1;
                const endIndex = Math.min(startIndex + this.itemsPerPage - 1, this.bootcamps.length);
                return `Mostrando ${startIndex}-${endIndex} de ${this.bootcamps.length} resultados`;
            },
        },
        mounted(){
            this.getData();
        },
        methods: {
            getData(){
                this.loading = true;
                axios.get(this.url).then(resp => {
                    this.bootcamps = resp.data;
                    this.loading = false;
                });
            },
            getFormattedTime(time){
                return time.replace('_', ' ');
            },
            updatePage(newPage) {
                this.page = newPage;

                this.$nextTick(() => {
                    const container = this.$refs.paginationContainer;
                    if (container) {
                        const containerTop = container.getBoundingClientRect().top;
                        window.scrollTo(0, (window.scrollY + containerTop) - 200);
                    }
                });
            },
            openEditModal(bootcamp){
                this.activeBootcamp = bootcamp;
                this.isEditModalVisible = true;
            },
            closeEditModal(){
                this.activeBootcamp = null;
                this.isEditModalVisible = false;
            },
            refreshBootcamps(){
                this.getData();
                this.closeEditModal();
            },
            onNewBootcamp(){
                this.getData();
                window.scrollTo({
                    top: 100,
                    behavior: 'smooth',
                });
            },
            onFilterSearch( searchText ){
                this.search = searchText;
            }
        }
    }
</script>
<style>
    .badge-bootcamp{
        background-color: #E0E2FF4D;
        color: #1A0054;
        font-size: 14px;
    }

    .badge-duration{
        background-color: #89D4F833;
        color: #494949;
        font-size: 14px;
    }

    .badge-duration .duration-icon{
        color: #4DBBDD;
    }

    .bootcamp-link{
        width: fit-content;
        font-weight: bold;
        font-size: 16px;
    }

    .bootcamp-link:hover{
        color: #1A0054 !important;
    }

    .custom-card-footer{
        background-color: transparent;
        border: none;
    }

    .updatebootcampbutton{
        position: absolute;
        right: 10px;
        top: 5px;
        padding: 5px;
        width: 50px;
        border-radius: 15px;
    }
</style>
